import React from 'react'
import { useDrawing } from '../../context/DrawingContext'
import styles from './ColorPalette.module.css'

const colors = [
  '#ff0000', // 빨강
  '#ff8c00', // 주황
  '#ffd700', // 노랑
  '#00ff00', // 초록
  '#0000ff', // 파랑
  '#8a2be2', // 보라
  '#ff69b4', // 분홍
  '#000000', // 검정
  '#808080', // 회색
  '#ffffff', // 흰색
  '#a0522d', // 갈색
  '#00ffff'  // 청록
]

const ColorPalette = () => {
  const { state, dispatch } = useDrawing()

  const handleColorChange = (color) => {
    dispatch({ type: 'SET_COLOR', payload: color })
    if (state.tool === 'eraser') {
      dispatch({ type: 'SET_TOOL', payload: 'pen' })
    }
  }

  const handleEraserClick = () => {
    if (state.tool === 'eraser') {
      dispatch({ type: 'SET_TOOL', payload: 'pen' })
    } else {
      dispatch({ type: 'SET_TOOL', payload: 'eraser' })
    }
  }

  return (
    <div className={styles.colorPalette}>
      <div className={styles.colorGrid}>
        {colors.map((color) => (
          <button
            key={color}
            className={`${styles.colorSwatch} ${
              state.color === color ? styles.active : ''
            }`}
            style={{ backgroundColor: color }}
            onClick={() => handleColorChange(color)}
            title={color}
          />
        ))}
      </div>
      
      <div className={styles.customColorSection}>
        <label className={styles.customColorLabel}>
          사용자 정의:
          <input
            type="color"
            value={state.color}
            onChange={(e) => handleColorChange(e.target.value)}
            className={styles.customColorInput}
          />
        </label>
        <button
          className={`${styles.eraserButton} ${
            state.tool === 'eraser' ? styles.active : ''
          }`}
          onClick={handleEraserClick}
          title="지우개"
        >
          <i className="fas fa-eraser"></i>
        </button>
      </div>
    </div>
  )
}

export default ColorPalette